import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import * as contactUsService from "../../services/contactUs.services";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDateWithMonth, handleServerValidations } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

// import $ from "jquery";

const ViewContactUs = (props) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("contact-us.link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("contact-us.link_contact_us"),
      url: "/admin/contact-us/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    contactUsService
      .Details({ _id: params.id })
      .then((response) => {
        console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  const markAsAcknowledged = () => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("contact-us.acknowledge_confirm_title"),
      text: t("contact-us.acknowledge_confirm_text"),
      icon: "question",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("contact-us.btn_acknowledge"),
    }).then((result) => {
      if (result.isConfirmed) {
        contactUsService
          .Acknowledge({ _id: params.id })
          .then((response) => {
            if (response.success) {
              setShowDefault(response.data || { ...showdefault, is_acknowledged: true, acknowledged_at: new Date() });
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("acknowledgeError", error);
          });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  {t("contact-us.view_contact_us")}
                </h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>

                        <tr>
                          <th>{t("contact-us.label_name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.name
                              ? showdefault.name
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_email")}</th>
                          <td>
                            {showdefault && showdefault.email
                              ? showdefault.email
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Subject</th>
                          <td>
                            {showdefault && showdefault.subject
                              ? showdefault.subject
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("contact-us.label_contact_us_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDateWithMonth(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("contact-us.label_acknowledgement")}</th>
                          <td>
                            {showdefault?.is_acknowledged ? (
                              <span className="badge badge-success">
                                {t("contact-us.status_acknowledged")}
                                {showdefault.acknowledged_at
                                  ? ` — ${formateDateWithMonth(showdefault.acknowledged_at)}`
                                  : ""}
                              </span>
                            ) : (
                              <span className="badge badge-warning">
                                {t("contact-us.status_pending")}
                              </span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>Message</th>
                          <td style={{ wordBreak: 'break-word' }}>
                            {showdefault && showdefault.message
                              ? capitalizeFirstLetter(showdefault.message)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>

            <div className="mt-2 back-button d-flex">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/contact-us/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
              {showdefault && Object.keys(showdefault).length > 0 && !showdefault.is_acknowledged ? (
                <button
                  className="btn ripple btn-success ms-2"
                  type="button"
                  onClick={markAsAcknowledged}
                >
                  {t("contact-us.btn_acknowledge")}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewContactUs;
